import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { WAREHOUSES_LIST } from 'api/query-keys.ts';
import type { TWarehouseType, WarehouseRes } from 'api/swagger';

interface IUseGetManyWarehousesParams {
  withDeprecated?: boolean;
  internalOnly?: boolean;
  type?: TWarehouseType;
}

export const useGetManyWarehouses = (params?: IUseGetManyWarehousesParams) => {
  const { withDeprecated, internalOnly, type } = params || {};

  const qs = new URLSearchParams();
  if (withDeprecated !== undefined) qs.set('filter[withDeprecated]', String(withDeprecated));
  if (internalOnly) qs.set('filter[internal]', 'true');
  if (type) qs.set('filter[type]', type);

  return useQuery<WarehouseRes[]>({
    queryKey: [WAREHOUSES_LIST, { withDeprecated, internalOnly, type }],
    queryFn: async () => {
      const { data } = await http.get<WarehouseRes[]>(`/v1/warehouses?${qs.toString()}`);

      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};
